import { forwardRef, type ComponentPropsWithoutRef } from 'react';

/**
 * Zero-size, out-of-flow anchor for a footer menu or popover whose tile has
 * folded into the primary nav More. The menu stays mounted and opens against
 * the footer, without the anchor taking a flex gap or a rail measurement.
 */
export const CollapsedFooterAnchor = forwardRef<
  HTMLLIElement,
  ComponentPropsWithoutRef<'li'>
>(function CollapsedFooterAnchor(props, ref) {
  return (
    <li
      {...props}
      ref={ref}
      aria-hidden
      tabIndex={-1}
      className="pointer-events-none absolute bottom-0 end-0 size-0"
    />
  );
});
